export const catalogCode = "admin_catalog"
export const commentsCode = "admin_comments"
export const usersCode = "admin_users"
export const channelPromopushkaCode = "admin_channel_promopushka"
export const shopsCode = "admin_shops"
export const promocodesCode = "admin_promocodes"
